import { normalize } from 'normalizr'
import * as R from 'ramda'

import { flyerListSchema } from 'redux/schemas'
import * as District from 'models/districts'
import * as School from 'models/schools'
import moment from 'moment'

export const RETRIEVE_DISTRICT_FLYERS_FROM_CACHE =
  'RETRIEVE_DISTRICT_FLYERS_FROM_CACHE'
export const REQUEST_DISTRICT_FLYERS = 'REQUEST_DISTRICT_FLYERS'
export const RECEIVE_DISTRICT_FLYERS = 'RECEIVE_DISTRICT_FLYERS'
export const REQUEST_ONE_DISTRICT_FLYER = 'REQUEST_ONE_DISTRICT_FLYER'
export const RECEIVE_ONE_DISTRICT_FLYER = 'RECEIVE_ONE_DISTRICT_FLYER'
export const REQUEST_ONE_SCHOOL_FLYER = 'REQUEST_ONE_SCHOOL_FLYER'
export const RECEIVE_ONE_SCHOOL_FLYER = 'RECEIVE_ONE_SCHOOL_FLYER'
export const RECEIVE_ERROR = 'flyers/RECEIVE_ERROR'

// const FLYER_MAX_CACHE_DURATION = 30 * 60 * 1000 * 1000 // 30 minutes

const receiveError = (error, districtId) => ({
  type: RECEIVE_ERROR,
  districtId,
  error
})

/*
 * Fetch all flyers for a school or district
 */

const requestDistrictFlyers = districtId => ({
  type: REQUEST_DISTRICT_FLYERS,
  districtId
})

const receiveDistrictFlyers = (districtId, normalizedFlyerData) => {
  const { flyers, schools, districts } = normalizedFlyerData.entities
  const { flyerAudienceInfo } = normalizedFlyerData
  const { result } = normalizedFlyerData

  return {
    type: RECEIVE_DISTRICT_FLYERS,
    districtId,
    flyers: flyers || {},
    schools: schools || {},
    district: districts ? districts[districtId] : {},
    allFlyers: result,
    flyerAudienceInfo: flyerAudienceInfo || {},
    receivedAt: Date.now()
  }
}

// const retrieveDistrictFlyersFromCache = {
//   type: RETRIEVE_DISTRICT_FLYERS_FROM_CACHE
// }

export const fetchDistrictFlyers = districtId => dispatch => {
  // const lastUpdated = getState().flyers.lastUpdated

  // if (Date.now() - lastUpdated <= FLYER_MAX_CACHE_DURATION) {
  //   dispatch(retrieveDistrictFlyersFromCache)
  //   return false
  // }

  dispatch(requestDistrictFlyers(districtId))
  return District.getAllFlyers(districtId)
    .then(data => {
      const json = data.flyers
      const flyerAudienceInfo = data.flyerAudienceInfo
      const missingPages = json.filter(f => !f.pages)
      if (missingPages.length > 0) {
        console.log('Some of our flyers are missing pages', missingPages)
      }
      // Normalizr doesn't support filtration of any kind, so we do this manually.
      // https://github.com/paularmstrong/normalizr/issues/306#issuecomment-345323149
      const normalizedFlyers = normalize(json, flyerListSchema)
      const flyerFilteredSchools = R.fromPairs(
        R.toPairs(normalizedFlyers.entities.schools).map(([sId, s]) => [
          sId,
          {
            ...s,
            flyers: s.flyers.filter(fId =>
              R.pathOr(true, [fId.toString(), sId], flyerAudienceInfo)
            )
          }
        ])
      )
      const normalizedFlyerData = {
        ...normalizedFlyers,
        entities: {
          ...normalizedFlyers.entities,
          // Use schools with filtered flyers
          schools: flyerFilteredSchools
        },
        // Don't normalize flyer audience info, just pass it in
        flyerAudienceInfo
      }

      dispatch(receiveDistrictFlyers(districtId, normalizedFlyerData))
    })
    .catch(err => dispatch(receiveError(err, districtId)))
}

/*
 * Fetch one flyer for a school or district
 */

const receiveOneFlyer = (flyer, schools, district, resource) =>
  // const { flyers, schools, districts } = normalizedFlyerData.entities
  // const { result } = normalizedFlyerData

  ({
    type:
      resource === 'schools'
        ? RECEIVE_ONE_SCHOOL_FLYER
        : RECEIVE_ONE_DISTRICT_FLYER,
    flyer,
    schools,
    district,
    receivedAt: Date.now()
  })

const requestOneSchoolFlyer = (resource, resourceId, flyerId) => ({
  type: REQUEST_ONE_SCHOOL_FLYER,
  resource,
  resourceId,
  flyerId
})

export const fetchOneSchoolFlyer = (schoolId, flyerId) => (
  dispatch
  // getState
) => {
  // const lastUpdated = getState().flyers.lastUpdated

  // if (Date.now() - lastUpdated <= FLYER_MAX_CACHE_DURATION) {
  //   dispatch(retrieveSchoolFlyersFromCache)
  //   return Promise.resolve(false)
  // }

  dispatch(requestOneSchoolFlyer(schoolId, flyerId))
  return School.getOneFlyer(schoolId, flyerId)
    .then(flyer => {
      const schoolIds = R.map(R.prop('school_id'), flyer.schools)
      const normFlyer = {
        ...flyer,
        schools: schoolIds,
        district_id: flyer.schools[0].district.district_id
      }
      const normSchools = R.reduce(
        (accum, school) => ({
          ...accum,
          [school.school_id]: {
            ...school,
            district_id: school.district.district_id,
            flyers: [flyerId]
          }
        }),
        {},
        flyer.schools
      )
      const normDistrict = {
        ...flyer.schools[0].district,
        schools: schoolIds,
        flyers: [flyerId]
      }
      const flyerMetrics = {
        flyerIds: [flyerId],
        district: normDistrict.district_id,
        school: schoolIds[0],
        eventTime: moment().format(),
        action: 'flyer-detail'
      }
      School.postOneFlyer({ body: flyerMetrics })
      return dispatch(
        receiveOneFlyer(normFlyer, normSchools, normDistrict, 'schools')
      )
    })
    .catch(err => dispatch(receiveError(err, schoolId)))
}

/*
 * Fetch one flyer for a school or district
 */

const requestOneDistrictFlyer = (resource, resourceId, flyerId) => ({
  type: REQUEST_ONE_DISTRICT_FLYER,
  resource,
  resourceId,
  flyerId
})

export const fetchOneDistrictFlyer = (districtId, flyerId) => (
  dispatch
  // getState
) => {
  // const lastUpdated = getState().flyers.lastUpdated

  // if (Date.now() - lastUpdated <= FLYER_MAX_CACHE_DURATION) {
  //   dispatch(retrieveDistrictFlyersFromCache)
  //   return Promise.resolve(false)
  // }

  dispatch(requestOneDistrictFlyer(districtId, flyerId))
  return District.getOneFlyer(districtId, flyerId)
    .then(flyer => {
      const schoolIds = R.map(R.prop('school_id'), flyer.schools)
      const normFlyer = {
        ...flyer,
        schools: schoolIds,
        district_id: flyer.schools[0].district.district_id
      }
      const normSchools = R.reduce(
        (accum, school) => ({
          ...accum,
          [school.school_id]: {
            ...school,
            district_id: school.district.district_id,
            flyers: [flyerId]
          }
        }),
        {},
        flyer.schools
      )
      const normDistrict = {
        ...flyer.schools[0].district,
        schools: schoolIds,
        flyers: [flyerId]
      }
      const flyerMetrics = {
        flyerIds: [flyerId],
        district: normDistrict.district_id,
        school: schoolIds[0],
        eventTime: moment().format(),
        action: 'flyer-detail'
      }
      District.postOneFlyer({ body: flyerMetrics })
      return dispatch(
        receiveOneFlyer(normFlyer, normSchools, normDistrict, 'districts')
      )
    })
    .catch(err => dispatch(receiveError(err, districtId)))
}



// WEBPACK FOOTER //
// ./src/shared/redux/flyers/actions.js